import {SearchParamsInterface} from "../interface/SearchParamsInterface";
import configAxios from "../configuration/configAxios";
import {interceptorResponse} from "../../utils/decode/decoding";
import {errorHandlerServices, getError} from "../configuration/errorHandle";
import {useMutation, UseMutationResult} from "@tanstack/react-query";

export const findChartRating = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/chart/credit_rating`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/chart/credit_rating', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /chart/credit_rating`);
    })
}

export const useFindChartRating = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findChartRating(data),
    });
}

export const findChartFinanceSummaryService = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/chart/financia_summary_service`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/chart/financia_summary_service', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /chart/financia_summary_service`);
    })
}

export const useFindChartFinanceSummaryService = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findChartFinanceSummaryService(data),
    });
}

export const findGraphicIncome = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/chart/monthly_income`,
        {
            identifier: data.identifier,
            filterByAxisX: data.months ? data.months : 12,
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/income/graphicMachining', undefined, data.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /chart/monthly_income`);
    })
}

export const useFindGraphicIncome = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findGraphicIncome(data),
    });
}

export const findGraphicPrediction = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/chart/monthly_income_prediction`,
        {
            identifier: data.identifier,
            filterByAxisX: data.months ? data.months : 12,
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/income/graphicMachining', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /chart/monthly_income_prediction`);
    })
}

export const useFindGraphicPrediction = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findGraphicPrediction(data),
    });
}
